import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22stem.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./StemFontFiles/Stem-SemiLight.woff2%22,%22weight%22:%22350%22,%22style%22:%22normal%22},{%22path%22:%22./StemFontFiles/Stem-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22}]}],%22variableName%22:%22stem%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'stem', 'stem Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
